export default {
  'landing.memory': 'اصنع ذكرياتك معنا',
  'landing.family': 'استمتع بأفضل الرحلات مع عائلتك وأصدقائك',
  'landing.providing':
    'توفير جميع الرحلات الجوية وأسهل عملية للبحث وشراء واسترداد تذاكر الطيران',
  'landing.price': 'أقل سعر لشراء تذاكر الطائرة مع خصم خاص',
  'landing.point': 'اكسب نقاط مع كل رحلة',
  'landing.buynow': 'اشتر الآن',
  'landing.scotland': 'السفر إلى اسكتلندا',
  'landing.ireland': 'السفر إلى إيرلندا',
  'landing.egypt': 'السفر إلى مصر',
  'landing.greece': 'السفر إلى اليونان',
  'landing.person': 'بعض الأشخاص قد ذهبوا',
  'landing.categories': 'الفئات',
};
